import { render, staticRenderFns } from "./FeaturesDashboard.vue?vue&type=template&id=33a0cbf7&scoped=true&"
import script from "./FeaturesDashboard.vue?vue&type=script&lang=js&"
export * from "./FeaturesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesDashboard.vue?vue&type=style&index=0&id=33a0cbf7&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a0cbf7",
  null
  
)

export default component.exports